module.exports = __webpack_public_path__ + "img/NGC-2070.ba1dd8c4.jpg";